const makeId = (length: Number): string => {
	var result = '';
	var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++)
	{
		result += characters.charAt(Math.floor(Math.random() *
			charactersLength));
	}
	return result;
}
export default makeId;